import React, { memo } from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import cls from './General.module.css';
import { useGeneral } from './useGeneral';
import { Input } from '../../../../../../components/newUI/Input/Input';
import { PhoneInputs } from '../../../../../../components/newUI/PhoneInput/PhoneInput';
import { TextArea } from '../../../../../../components/newUI/TextArea/TextArea';
import { Customer } from '../../../../types/dashboardInformation';
import { ErrorValidate } from '../../useModalCustomer';

interface GeneralProps {
    classes?: string;
    form: Customer;
    onForm: (name: string, value: string) => void;
    errorValidate: ErrorValidate;
}

export const General = memo(({ classes, onForm, form, errorValidate }: GeneralProps) => {
    const { modalMode } = useGeneral();

    const { t } = useTranslation();

    return (
        <div className={classNames(cls.General, [classes])}>
            <Input
                value={form.name ? form.name : ''}
                label={t('General.return.inputName.label')}
                placeholder={t('General.return.inputName.placeholder')}
                error={errorValidate.name}
                inputName="name"
                onChange={onForm}
                maxLength={128}
                message={t('General.return.inputName.message')}
            />
            <div className={cls.inputRow}>
                <Input
                    isDisabled={modalMode === 'editCustomer'}
                    value={form.email ? form.email : ''}
                    label={t('General.return.inputEmail.label')}
                    placeholder={t('General.return.inputEmail.placeholder')}
                    error={errorValidate.email}
                    inputName="email"
                    onChange={onForm}
                    maxLength={64}
                    classes={cls.inputRowItem}
                />
                <PhoneInputs
                    inputName="phone"
                    label={t('General.return.inputPhone.label')}
                    placeholder={t('General.return.inputPhone.placeholder')}
                    onChange={onForm}
                    value={form.phone ? form.phone : ''}
                    classes={cls.inputRowItem}
                />
            </div>

            <TextArea
                inputName="description"
                onChange={onForm}
                value={form.description ? form.description : ''}
                label={t('General.return.textareaDescription.label')}
                maxLength={512}
                classes={cls.textarea}
            />
            <Input
                classes={cls.withBorder}
                value={form.contact_name ? form.contact_name : ''}
                label={t('General.return.inputContactName.label')}
                errorMessage=""
                inputName="contact_name"
                onChange={onForm}
                maxLength={64}
            />
            <Input
                value={form.actual_address ? form.actual_address : ''}
                label={t('General.return.inputActualAddress.label')}
                errorMessage=""
                inputName="actual_address"
                onChange={onForm}
                maxLength={256}
            />
            <TextArea
                inputName="contact_comment"
                onChange={onForm}
                value={form.contact_comment ? form.contact_comment : ''}
                label={t('General.return.textareaContactComment.label')}
                classes={cls.textarea}
                maxLength={512}
            />
        </div>
    );
});
